import { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";
import { PaperPlaneTilt } from "@phosphor-icons/react";

export default function NewsletterForm({ source = "site", theme = "light" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email, source);
      toast.success("Welcome aboard. Watch your inbox for our next dispatch.");
      setEmail("");
    } catch (err) {
      toast.error("We couldn’t register your email right now. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const dark = theme === "dark";

  return (
    <form
      onSubmit={submit}
      className={`flex items-center gap-2 rounded-full p-1.5 ${dark ? "bg-white/10 ring-1 ring-white/15" : "bg-white ring-1 ring-ink/10 card-shadow"}`}
      data-testid={`newsletter-form-${source}`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        data-testid={`newsletter-email-${source}`}
        className={`flex-1 bg-transparent px-4 py-2 outline-none text-sm ${dark ? "text-white placeholder-white/40" : "text-ink placeholder-ink/40"}`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`newsletter-submit-${source}`}
        className="btn-gold rounded-full px-4 py-2 text-sm font-medium inline-flex items-center gap-2 disabled:opacity-60"
      >
        <PaperPlaneTilt size={16} weight="bold" />
        {loading ? "Subscribing..." : "Subscribe"}
      </button>
    </form>
  );
}
